import React from "react";

//Images
import antiqueCobble from "../../../images/variations/shapes-antiqueCobble.png";
import modularStone from "../../../images/variations/shapes-modularStone.png";
import twelveByTwelve from "../../../images/variations/shapes-twelveByTwelve.png";
import comboStone from "../../../images/variations/shapes-comboStone.png";
import plankStone from "../../../images/variations/shapes-plankStone.png";
import serpentine from "../../../images/variations/shapes-serpentine.png";
import bishopHat from "../../../images/variations/shapes-bishopHat.png";
import turfStone from "../../../images/variations/shapes-turfStone.png";
import slab from "../../../images/variations/shapes-slab.png";
import permeableHollandStone from "../../../images/variations/shapes-permeableHollandStone.png";

const Shapes = () => {
  const shapes = [
    {
      title: "Antique Cobble",
      image: antiqueCobble,
    },
    {
      title: "Modular Stone",
      image: modularStone,
    },
    {
      title: "12x12",
      image: twelveByTwelve,
    },
    {
      title: "Combo Stone",
      image: comboStone,
    },
    {
      title: "Plank Stone",
      image: plankStone,
    },
    {
      title: "Serpentine",
      image: serpentine,
    },
    {
      title: "Bishop Hat",
      image: bishopHat,
    },
    {
      title: "Turf Stone",
      image: turfStone,
    },
    {
      title: "Slab",
      image: slab,
    },
    {
      title: "Permeable Holland Stone",
      image: permeableHollandStone,
    },
  ];

  const mapShapes = () => {
    return shapes.map((shape, index) => {
      return (
        <div className={`col-5 col-md-2 shape-item mt-3 text-center ${index === 0 || index === 5 ? "offset-md-1" : ""}`} key={index}>
          <div className="image">
            <img src={shape.image} alt={shape.title} />
          </div>
          <p>{shape.title}</p>
        </div>
      );
    });
  };

  return <div className="row justify-content-center justify-content-md-start panel-shapes">
    <div className="col-12 text-uppercase text-center mb-5">
      <h3 className="text-blue">
        Paver Shapes
      </h3>
    </div>
    {mapShapes()}
  </div>;
};

export default Shapes;
